export default __webpack_public_path__ + "static/media/loading.ac789a98.svg";